import { render, staticRenderFns } from "./GroupCall.vue?vue&type=template&id=11ab3440&scoped=true&"
import script from "./GroupCall.vue?vue&type=script&lang=js&"
export * from "./GroupCall.vue?vue&type=script&lang=js&"
import style0 from "./GroupCall.vue?vue&type=style&index=0&id=11ab3440&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ab3440",
  null
  
)

export default component.exports